module.exports = __webpack_public_path__ + "assets/img/21_754_big.f60bbac5.jpg";